export const WARNING_STRINGS = {
	TITLE: 'Tem certeza?',
	TEXT: 'Enviar seu número de telefone, e-mail, PINs, senhas e outros dados é arriscado e pode expor você a fraudes. Você quer mesmo assumir esse risco e continuar?',
	CONTINUE_BUTTON: 'Sim, quero assumir esse risco',
	CANCEL_BUTTON: 'Não',
} as const;
